module.exports = __webpack_public_path__ + "assets/images/heart_disease_g.25e9f340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/heart_disease_g.png
// module id = 729
// module chunks = 1